import { GallerySliderWrapper } from '@lsg/shared';
import { createElement } from 'react';
import { GallerySliderItem } from '../GallerySliderItem/GallerySliderItem.js';

/** @deprecated (date: 18.11.2021 */

var Looks;

(function (Looks) {
  Looks["CARDS"] = "cards";
})(Looks || (Looks = {}));

var GallerySlider = function GallerySlider(props) {
  return /*#__PURE__*/createElement(GallerySliderWrapper, Object.assign({}, props));
};

GallerySlider.displayName = "GallerySlider";
GallerySlider.Item = GallerySliderItem;
GallerySlider.Looks = Looks;

export { GallerySlider };
